// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sticky-navigation-menu-item[data-v-6fa13017]{transition-property:all;transition-duration:.2s;transition-delay:.1s;transition-timing-function:cubic-bezier(.4,0,1,1)}.sticky-navigation-menu-item-active[data-v-6fa13017]{top:-1rem!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
